import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=781f547a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781f547a"]])

export default __exports__